/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discounts_PlansInputs */

const en_admin_discounts_plans = /** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membership Plans`)
};

const de_admin_discounts_plans = /** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitgliedschaftstarife`)
};

const es_admin_discounts_plans = /** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planes de suscripción`)
};

const fr_admin_discounts_plans = /** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forfaits d'adhésion`)
};

const nl_admin_discounts_plans = /** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lidmaatschapsabonnementen`)
};

/** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */
const it_admin_discounts_plans = en_admin_discounts_plans;

/** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */
const pt_br2_admin_discounts_plans = en_admin_discounts_plans;

/** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */
const pl_admin_discounts_plans = en_admin_discounts_plans;

/** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */
const hu_admin_discounts_plans = en_admin_discounts_plans;

/** @type {(inputs: Admin_Discounts_PlansInputs) => LocalizedString} */
const ro_admin_discounts_plans = en_admin_discounts_plans;

/**
* | output |
* | --- |
* | "Membership Plans" |
*
* @param {Admin_Discounts_PlansInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discounts_plans = /** @type {((inputs?: Admin_Discounts_PlansInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discounts_PlansInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discounts_plans(inputs)
	if (locale === "de") return de_admin_discounts_plans(inputs)
	if (locale === "es") return es_admin_discounts_plans(inputs)
	if (locale === "fr") return fr_admin_discounts_plans(inputs)
	if (locale === "nl") return nl_admin_discounts_plans(inputs)
	if (locale === "it") return it_admin_discounts_plans(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discounts_plans(inputs)
	if (locale === "pl") return pl_admin_discounts_plans(inputs)
	if (locale === "hu") return hu_admin_discounts_plans(inputs)
	return ro_admin_discounts_plans(inputs)
});
export { admin_discounts_plans as "admin.discounts.plans" }